export default __webpack_public_path__ + "static/media/select-lot.33578df2.svg";